export const routeToComponentName = route => {
	const slugPart = snakeToCamel( route.post_type );
	const templatePart = route.template.trim() !== '' ? snakeToCamel( route.template ) : '';

	return `${ slugPart }${templatePart}`;
};

// https://coderwall.com/p/iprsng/convert-snake-case-to-camelcase
function snakeToCamel( s ){
	return s
		.trim()
		.replace(/(\[_-]\w)/g, m => m[1].toUpperCase() )
		.replace(/(^.)/g, m => m[0].toUpperCase() );
}



// WEBPACK FOOTER //
// ./assets/_js/utils/route-to-component-name.js